class RotatingBadge extends HTMLElement {
  constructor() {
    super();
    this.handleScroll = this.handleScroll.bind(this);
    this.rotation = 0;
  }

  get shouldRotate() {
    return this.dataset.rotateOnScroll === 'true';
  }

  connectedCallback() {
    if (this.shouldRotate && !FoxTheme.config.motionReduced) {
      this.setupRotation();
    }
  }

  disconnectedCallback() {
    if (this.shouldRotate) {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }

  setupRotation() {
    this.badgeImage = this.querySelector('.image-with-text__badge-img');
    if (!this.badgeImage) return;

    // Set transform origin to center
    this.badgeImage.style.transformOrigin = 'center center';

    // Add scroll listener
    window.addEventListener('scroll', this.handleScroll, { passive: true });

    // Initial rotation
    this.handleScroll();
  }

  handleScroll() {
    if (!this.badgeImage) return;

    // Get scroll position
    const scrollY = window.scrollY || window.pageYOffset;

    // Calculate rotation based on scroll (1 full rotation per 1000px of scroll)
    this.rotation = (scrollY / 1000) * 360;

    // Apply rotation
    requestAnimationFrame(() => {
      this.badgeImage.style.transform = `rotate(${this.rotation}deg)`;
    });
  }
}

customElements.define('rotating-badge', RotatingBadge);
